export default "__VITE_ASSET__D$ht6JJK__"